export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5295.0cbb8b5d.jpg";